import { render, staticRenderFns } from "./licenseList.vue?vue&type=template&id=339fc664"
import script from "./licenseList.vue?vue&type=script&lang=js"
export * from "./licenseList.vue?vue&type=script&lang=js"
import style0 from "./licenseList.vue?vue&type=style&index=0&id=339fc664&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports